import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DsSegmentedOptionComponent } from "./ds-segmented-option.component";
import { DsIconModule } from "../ds-icon/ds-icon.module";
@NgModule({
  declarations: [DsSegmentedOptionComponent],
  imports: [CommonModule, DsIconModule],
  exports: [DsSegmentedOptionComponent],
})
export class DsSegmentedOptionModule {}
